<div class="content dark">
	<div class="row">
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">Operations</div>
				<div class="content">
					<div class="row">
						<label class="col-md-4 col-form-label">Before operation:</label>
						<div class="col-md-8">
							<select class="form-control form-control-sm" [(ngModel)]="opBefore" (ngModelChange)="updatePlot()">
								<option *ngFor="let operation of operations" [ngValue]="operation">
									{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
									runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}
								</option>
							</select>
						</div>
					</div>
					<div class="row">
						<label class="col-md-4 col-form-label">After operation:</label>
						<div class="col-md-8">
							<select class="form-control form-control-sm" [(ngModel)]="opAfter" (ngModelChange)="updatePlot()">
								<option *ngFor="let operation of operations" [ngValue]="operation">
									{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
									runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}
								</option>
							</select>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="rotor && adjustments" class="item-panel">
				<div class="heading">Adjustments</div>
				<div class="content">
					<p>Adjustments:</p>
					<table class="table adjustments">
						<tr>
							<th></th>
							<th *ngFor="let blade of rotor.blade">{{blade.name}}</th>
						</tr>
						<tr *ngFor="let adjdef of rotor.adjdef; let i = index">
							<th>{{ adjdef.name }}</th>
							<td *ngFor="let blade of rotor.blade; let j = index">
								<input type="number" step="any" class="form-control" [(ngModel)]="adjustments[i][j]">
							</td>
						</tr>
					</table>
				</div>
			</div>
			<div *ngIf="rotor.balancedata && rotor.balancedata.numblades >= 4 && !rotor.balancedata.oneperrev" class="row">
				<div class="col-sm-4">
					Shaft Order
				</div>
				<div class="col-sm-8">
					<div class="form-check form-check-inline">
						<label class="form-check-label">
							<input [(ngModel)]="shaftOrder" class="form-check-input" type="radio" [value]="1" (ngModelChange)="updateBothPlots()"> 1/rev
						</label>
					</div>
					<div class="form-check form-check-inline">
						<label class="form-check-label">
							<input [(ngModel)]="shaftOrder" class="form-check-input" type="radio" [value]="2" (ngModelChange)="updateBothPlots()"> 2/rev
						</label>
					</div>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col-lg-6">
					<app-action-button [action]="CalculateCoefficients" [context]="this" processing="Calculating..." complete="Complete">Calculate Coefficients</app-action-button>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">Blade track</div>
				<div class="content">
					<app-dvs-chart [options]="trackOptions" [light]="true" [height]="'400px'" [error]="errormessage"></app-dvs-chart>
					<div *ngIf="trackOptions" class="legend">
						<span class="legend-item">
							<span class="swatch" style="background-color: #027A85"></span> Before Averages
						</span>
						<span class="legend-item">
							<span class="swatch" style="background-color: #DBCD00"></span> After Averages
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="coefficientText" class="row">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">Result</div>
				<div class="content">
					<textarea [(ngModel)]="coefficientText" style="width: 100%;height: 400px;" readonly></textarea>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<div class="item-panel">
				<div class="heading">Track Split</div>
				<div class="content">
					<app-dvs-chart [options]="timelineOptions" [light]="true" [height]="'300px'">
					</app-dvs-chart>
					<div *ngIf="timelineOptions && adjustments && adjustments.length" class="legend">
						<span class="legend-item">
							<span class="swatch" style="background-color: #f3f700"></span> Adjustment (see below)
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>